import { ToastStatus } from '../toast.type';

export const getToastErrorDetails = (status: ToastStatus, message: string) => {
  const supportIdTextIndex = message.indexOf('Support ID:');
  const isSupportError = supportIdTextIndex > 0;

  let errorMessage = '';
  let supportIdText = '';
  if (isSupportError && (status === 'error' || status === 'alert')) {
    errorMessage = message.substring(0, supportIdTextIndex);
    supportIdText = message.substring(supportIdTextIndex);
  }
  return {
    isSupportError,
    errorMessage,
    supportIdText
  };
};
